import React from "react";
import { Lock, Bell, Zap, Globe } from "lucide-react";
import { NIGHT_2, BORDER_ON_DARK, TEXT_DIM_ON_DARK, MINT, CONTAINER } from "../tokens";

export default function ProofBar() {
  const items = [
    { icon: Lock, label: "Bank grade security" },
    { icon: Bell, label: "Clock-out reminders" },
    { icon: Zap, label: "Hours filled automatically" },
    { icon: Globe, label: "Multi country payroll ready" },
  ];
  return (
    <section style={{ background: NIGHT_2, padding: "22px 0", borderTop: "0.5px solid " + BORDER_ON_DARK, borderBottom: "0.5px solid " + BORDER_ON_DARK }}>
      <div style={{ ...CONTAINER, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 9, color: TEXT_DIM_ON_DARK }}>
              <Icon size={16} color={MINT} />
              <span style={{ fontSize: 13, fontWeight: 600 }}>{it.label}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}